import React from 'react';
import MultiImageSection from './MultiImageSection';
import { GiBrain } from 'react-icons/gi';

function NewVisualizationSection({ 
  images, 
  onAddImage, 
  onDeleteImage 
}) {
  return (
    <MultiImageSection
      title="Visualizzazione"
      description="Carica fino a 5 immagini per visualizzare i tuoi obiettivi e sogni."
      icon={GiBrain}
      colorClass="purple"
      images={images}
      onAddImage={onAddImage}
      onDeleteImage={onDeleteImage}
      maxImages={5}
    />
  );
}

export default NewVisualizationSection;